import VenuePortalUserOptionsAutocomplete from "@/components/VenuePortalUserOptionsAutocomplete/VenuePortalUserOptionsAutocomplete";
import { Drawer, Toolbar } from "@mui/material";
import { DrawerProps } from "./DrawerButton";

export default function ImpersonationDrawer({
  open,
  handleClose,
}: DrawerProps) {
  return (
    <Drawer open={open} onClose={handleClose} anchor="top">
      <Toolbar />
      <VenuePortalUserOptionsAutocomplete onChangeCallback={handleClose} />
    </Drawer>
  );
}
